var React = require('react');

function Ee (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("rect",{"width":"640","height":"477.9","rx":"0","ry":"0","key":0}),React.createElement("rect",{"width":"640","height":"159.3","y":"320.7","fill":"#fff","rx":"0","ry":"0","key":1}),React.createElement("path",{"fill":"#1291ff","d":"M0 0h640v159.3H0z","key":2})]));
}

Ee.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ee;

Ee.default = Ee;
